"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.string.fixed.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.index-of.js");

var _checkbox = _interopRequireDefault(require("element-ui/lib/checkbox"));

var _tag = _interopRequireDefault(require("element-ui/lib/tag"));

var _tooltip = _interopRequireDefault(require("element-ui/lib/tooltip"));

var _dom = require("element-ui/lib/utils/dom");

var _sortablejs = _interopRequireDefault(require("sortablejs"));

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _vue = _interopRequireDefault(require("vue"));

var _filterPanel = _interopRequireDefault(require("./filter-panel.js"));

var _layoutObserver = _interopRequireDefault(require("./layout-observer"));

var _util = require("./util");

/* eslint-disable no-useless-call */

/* eslint-disable no-prototype-builtins */
// 扩展拖拽排序组件

/** **/

/** **/
var getAllColumns = function getAllColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push(column);
      result.push.apply(result, getAllColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

var convertToRows = function convertToRows(originColumns) {
  var maxLevel = 1;

  var traverse = function traverse(column, parent) {
    if (parent) {
      column.level = parent.level + 1;

      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }

    if (column.children) {
      var colSpan = 0;
      column.children.forEach(function (subColumn) {
        traverse(subColumn, column);
        colSpan += subColumn.colSpan;
      });
      column.colSpan = colSpan;
    } else {
      column.colSpan = 1;
    }
  };

  originColumns.forEach(function (column) {
    column.level = 1;
    traverse(column);
  });
  var rows = [];

  for (var i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  var allColumns = getAllColumns(originColumns);
  allColumns.forEach(function (column) {
    if (!column.children) {
      column.rowSpan = maxLevel - column.level + 1;
    } else {
      column.rowSpan = 1;
    }

    rows[column.level - 1].push(column);
  });
  return rows;
};

var _default2 = {
  name: 'ElTableHeader',
  mixins: [_layoutObserver["default"]],
  render: function render(h) {
    var _this = this;

    var _vm = this;

    var originColumns = this.store.states.originColumns;
    var columnRows = convertToRows(originColumns, this.columns); // 是否拥有多级表头

    var isGroup = columnRows.length > 1;
    if (isGroup) this.$parent.isGroup = true;
    return h("table", {
      "class": "el-table__header",
      "attrs": {
        "cellspacing": "0",
        "cellpadding": "0",
        "border": "0"
      }
    }, [h("colgroup", [this._l(this.columns, function (column) {
      return h("col", {
        "directives": [{
          name: "show",
          value: column.show
        }],
        "attrs": {
          "name": column.id
        }
      });
    }), this.hasGutter ? h("col", {
      "attrs": {
        "name": "gutter"
      }
    }) : '']), h("thead", {
      "class": [{
        'is-group': isGroup,
        'has-gutter': this.hasGutter
      }]
    }, [this._l(columnRows, function (columns, rowIndex) {
      return h("tr", (0, _babelHelperVueJsxMergeProps["default"])([{
        "ref": "sortableRef",
        "class": _this.getHeaderRowClass(rowIndex)
      }, {
        style: _vm._px2rem(_this.getHeaderRowStyle(rowIndex), 24, [])
      }]), [_this._l(columns, function (column, cellIndex) {
        return h("th", (0, _babelHelperVueJsxMergeProps["default"])([{
          "key": cellIndex + (column.property || column.label),
          "attrs": {
            "colspan": column.colSpan,
            "rowspan": column.rowSpan
          },
          "on": {
            "mousemove": function mousemove($event) {
              return _this.handleMouseMove($event, column, cellIndex);
            },
            "mouseout": _this.handleMouseOut,
            "mouseenter": function mouseenter($event) {
              return _this.handleCellMouseEnter($event, column);
            },
            "mouseleave": _this.handleCellMouseLeave,
            "mousedown": function mousedown($event) {
              return _this.handleMouseDown($event, column, cellIndex);
            },
            "click": function click($event) {
              return _this.handleHeaderClick($event, column);
            },
            "contextmenu": function contextmenu($event) {
              return _this.handleHeaderContextMenu($event, column);
            }
          },
          "class": _this.getHeaderCellClass(rowIndex, cellIndex, columns, column)
        }, {
          style: _vm._px2rem(_this.getHeaderCellStyle(rowIndex, cellIndex, columns, column), 24, [])
        }]), [h("div", {
          "class": ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName]
        }, [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, {
          column: column,
          $index: cellIndex,
          store: _this.store,
          _self: _this.$parent.$vnode.context
        }) : column.columnLabel || column.label, column.sortable ? h("span", {
          "class": "caret-wrapper",
          "on": {
            "click": function click($event) {
              return _this.handleSortClick($event, column);
            }
          }
        }, [h("i", {
          "class": "sort-caret ascending",
          "on": {
            "click": function click($event) {
              return _this.handleSortClick($event, column, 'ascending');
            }
          }
        }), h("i", {
          "class": "sort-caret descending",
          "on": {
            "click": function click($event) {
              return _this.handleSortClick($event, column, 'descending');
            }
          }
        })]) : '', column.filters && column.filters.length || column.filterMethod ? h("span", {
          "class": "el-table__column-filter-trigger",
          "on": {
            "click": function click($event) {
              return _this.handleFilterClick($event, column);
            }
          }
        }, [h("i", {
          "class": ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : '']
        })]) : ''])]);
      }).concat(h("el-tooltip", {
        "attrs": {
          "effect": _this.table.tooltipEffect,
          "placement": "top"
        },
        "ref": "tooltip"
      }, [h("div", {
        "slot": "content"
      })])), _this.hasGutter ? h("th", {
        "class": "gutter"
      }) : '']);
    })])]);
  },
  props: {
    fixed: String,
    store: {
      required: true
    },
    border: Boolean,
    defaultSort: {
      type: Object,
      "default": function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },
  components: {
    ElCheckbox: _checkbox["default"],
    ElTag: _tag["default"],
    ElTooltip: _tooltip["default"]
  },
  computed: {
    table: function table() {
      return this.$parent;
    },
    // 扩展
    dragSort: function dragSort() {
      return this.table.columnDragSortable;
    },
    isAllSelected: function isAllSelected() {
      return this.store.states.isAllSelected;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    hasGutter: function hasGutter() {
      return !this.fixed && this.tableLayout.gutterWidth;
    }
  },
  created: function created() {
    this.filterPanels = {};
    this.activateTooltip = (0, _debounce["default"])(50, function (tooltip) {
      return tooltip.handleShowPopper();
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this$defaultSort = this.defaultSort,
        prop = _this$defaultSort.prop,
        order = _this$defaultSort.order;
    this.store.commit('sort', {
      prop: prop,
      order: order
    });
    /** 扩展 列拖拽排序 **/

    if (this.dragSort) {
      this.dragSortHandle = _sortablejs["default"].create(this.$refs.sortableRef, {
        dataIdAttr: 'data-id',
        filter: '.not-drag-position',
        group: {
          pull: false
        },
        // filter: '.el-table-column--selection',
        // Element dragging started
        draggable: '.can-drag-sort',
        // filter: evt => {
        //   return true;
        // },
        onEnd: function onEnd(evt) {
          var columns = _this2.store.states._columns;
          var index = columns.findIndex(function (d) {
            return d.type === 'index' || d.type === 'selection';
          });
          var fromIndex = evt.oldIndex;
          var toIndex = evt.newIndex;

          if (index === 0) {
            fromIndex = fromIndex + 1;
            toIndex = toIndex + 1;
          }

          var tempIndex = columns.splice(fromIndex, 1)[0];
          columns.splice(toIndex, 0, tempIndex);

          _this2.table.$emit('column-order-change', columns.map(function (column, index) {
            return {
              prop: column.property,
              index: index,
              show: column.show
            };
          })); // 扩展 设置正在进行排序拖拽的状态


          _this2.store.isSortDragging(true);

          _this2.store.scheduleLayout(true);

          for (var pro in _this2.filterPanels) {
            if (_this2.filterPanels.hasOwnProperty(pro)) {
              _this2.filterPanels[pro].showPopper = false;
            }
          }

          _this2.table.updateScroll();
        }
      });
    }
    /** **/

  },
  beforeDestroy: function beforeDestroy() {
    var panels = this.filterPanels;

    for (var prop in panels) {
      if (panels.hasOwnProperty(prop) && panels[prop]) {
        panels[prop].$destroy(true);
      }
    }
  },
  methods: {
    isCellHidden: function isCellHidden(index, columns) {
      var start = 0;

      for (var i = 0; i < index; i++) {
        start += columns[i].colSpan;
      }

      var after = start + columns[index].colSpan - 1;

      if (this.fixed === true || this.fixed === 'left') {
        return after >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return start < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
      var headerRowStyle = this.table.headerRowStyle;

      if (typeof headerRowStyle === 'function') {
        return headerRowStyle.call(null, {
          rowIndex: rowIndex
        });
      }

      return headerRowStyle;
    },
    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
      var classes = [];
      var headerRowClassName = this.table.headerRowClassName;

      if (typeof headerRowClassName === 'string') {
        classes.push(headerRowClassName);
      } else if (typeof headerRowClassName === 'function') {
        classes.push(headerRowClassName.call(null, {
          rowIndex: rowIndex
        }));
      }

      return classes.join(' ');
    },
    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
      var headerCellStyle = this.table.headerCellStyle;

      if (typeof headerCellStyle === 'function') {
        return headerCellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }

      return headerCellStyle;
    },
    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];

      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
        classes.push('is-hidden');
      }

      if (!column.children) {
        classes.push('is-leaf');
      }
      /** 扩展列显示隐藏 **/


      if (!column.show) {
        classes.push('is-noshow');
      }

      if (column.sortable) {
        classes.push('is-sortable');
      }
      /** 扩展筛选鼠标样式 **/


      if (column.filters) {
        classes.push('is-filters');
      }

      var headerCellClassName = this.table.headerCellClassName;

      if (typeof headerCellClassName === 'string') {
        classes.push(headerCellClassName);
      } else if (typeof headerCellClassName === 'function') {
        classes.push(headerCellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      } // 扩展 列类型新增radio


      if (column.type !== 'index' && column.type !== 'selection' && column.type !== 'radio') {
        classes.push('can-drag-sort');
      }

      return classes.join(' ');
    },
    toggleAllSelection: function toggleAllSelection() {
      this.store.commit('toggleAllSelection');
    },
    handleFilterClick: function handleFilterClick(event, column) {
      event.stopPropagation();
      var target = event.target;
      var cell = target.tagName === 'TH' ? target : target.parentNode;
      cell = cell.querySelector('.el-table__column-filter-trigger') || cell;
      var table = this.$parent;
      var filterPanel = this.filterPanels[column.id];
      /** *扩展 */

      if (filterPanel && column.filterOpened) {
        filterPanel.showPopper = false;
        return;
      }

      if (!filterPanel) {
        filterPanel = new _vue["default"](Object.assign(_filterPanel["default"], {
          parent: this
        }));
        this.filterPanels[column.id] = filterPanel; // if (column.filterPlacement) {
        //   filterPanel.placement = column.filterPlacement
        // }

        filterPanel.table = table;
        filterPanel.cell = cell;
        filterPanel.column = column; // 扩展，赋值header 引用给 filterPanel

        /** **/

        filterPanel.header = this;
        /** **/

        !this.$isServer && filterPanel.$mount(document.createElement('div'));
      }

      setTimeout(function () {
        // 扩展
        filterPanel.popperJS && filterPanel.popperJS.updateReference(cell);
        filterPanel.showPopper = true;
      }, 16);
    },
    handleHeaderClick: function handleHeaderClick(event, column) {
      // 扩展 如果是调整宽度的拖拽不触发click事件
      if (!this.store.states.isDragging) {
        if (!column.filters && column.sortable) {
          this.handleSortClick(event, column);
        } else if (column.filterable && !column.sortable) {
          this.handleFilterClick(event, column);
        }
      }

      this.$parent.$emit('header-click', column, event);
    },
    handleHeaderContextMenu: function handleHeaderContextMenu(event, column) {
      this.$parent.$emit('header-contextmenu', column, event);
    },
    handleMouseDown: function handleMouseDown(event, column, cellIndex) {
      var _this3 = this;

      // 扩展
      // 扩展 设置正在进行调整宽度的拖拽状态
      this.store.isDragging(false);
      if (this.$isServer) return; //

      if (cellIndex >= this.columns.length - 1) {
        return;
      }

      if (column.children && column.children.length > 0) return;
      /* istanbul ignore if */

      /** *扩展 不局限当有边框，列能拖拽调整宽度***/
      // if (this.draggingColumn && this.border) {

      if (this.draggingColumn) {
        this.dragging = true; // 扩展 设置正在进行调整宽度的拖拽状态

        this.store.isDragging(true); // 扩展 设置正在进行调整宽度的列

        this.store.setCurrentCol(column);
        this.$parent.resizeProxyVisible = true;
        var table = this.$parent;
        var tableEl = table.$el;
        var tableLeft = tableEl.getBoundingClientRect().left;
        var columnEl = this.$el.querySelector("th.".concat(column.id));
        var columnRect = columnEl.getBoundingClientRect();
        var minLeft = columnRect.left - tableLeft + (this.draggingColumn.minWidth || 100); // 修复调整列宽最小宽度导致tooltip显示bug,拖动最小是100
        // const minLeft = columnRect.left - tableLeft + 50;

        (0, _dom.addClass)(columnEl, 'noclick');
        this.dragState = {
          startMouseLeft: event.clientX,
          startLeft: columnRect.right - tableLeft,
          startColumnLeft: columnRect.left - tableLeft,
          tableLeft: tableLeft
        }; // 记录最原始用户初始化的，宽度

        if (!column._originalWidth) {
          column._originalWidth = columnRect.width;
        }

        var resizeProxy = table.$refs.resizeProxy;
        resizeProxy.style.left = this.dragState.startLeft + 'px';

        document.onselectstart = function () {
          return false;
        };

        document.ondragstart = function () {
          return false;
        };

        var handleMouseMove = function handleMouseMove(event) {
          var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
          var proxyLeft = _this3.dragState.startLeft + deltaLeft;
          resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
        }; // const handleMouseMove = (event) => {
        //   // const deltaLeft = event.clientX - this.dragState.startMouseLeft;
        //   // const proxyLeft = Math.min(this.dragState.startLeft + deltaLeft, 300);
        //   // resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
        //   const deltaLeft = event.clientX - this.dragState.startMouseLeft;
        //   const resizeMaxWidth = column._originalWidth + 200; // 拖动最大比最初的宽大200
        //   const proxyLeft = Math.min(this.dragState.startLeft + deltaLeft, resizeMaxWidth);
        //   resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
        // };


        var handleMouseUp = function handleMouseUp() {
          if (_this3.dragging) {
            var _this3$dragState = _this3.dragState,
                startColumnLeft = _this3$dragState.startColumnLeft,
                startLeft = _this3$dragState.startLeft;
            var finalLeft = parseInt(resizeProxy.style.left, 10);
            var columnWidth = finalLeft - startColumnLeft;
            column.width = column.realWidth = columnWidth;
            table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);

            _this3.store.scheduleLayout();

            document.body.style.cursor = '';
            _this3.dragging = false;
            _this3.draggingColumn = null;
            _this3.dragState = {};
            table.resizeProxyVisible = false;
          }

          document.removeEventListener('mousemove', handleMouseMove);
          document.removeEventListener('mouseup', handleMouseUp);
          document.onselectstart = null;
          document.ondragstart = null;
          setTimeout(function () {
            (0, _dom.removeClass)(columnEl, 'noclick');
          }, 0); // 扩展

          setTimeout(function () {
            table.updateScroll();
          }, 300); // 释放sortable中的拖拽元素

          _this3.dragSortHandle && _this3.dragSortHandle._onDrop();
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
      }
    },
    handleMouseMove: function handleMouseMove(event, column, cellIndex) {
      // 扩展

      /** *扩展 */
      if (cellIndex >= this.columns.length - 1) {
        return;
      }
      /**  */


      if (column.children && column.children.length > 0) return;
      var target = event.target;

      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (!column || !column.resizable) {
        this.draggingColumn = null;
        return;
      }
      /** *扩展 不局限当有边框，列能拖拽调整宽度***/
      // if (!this.dragging && this.border) {


      if (!this.dragging) {
        var rect = target.getBoundingClientRect();
        var bodyStyle = document.body.style;

        if (rect.width > 12 && rect.right - event.pageX < 8) {
          bodyStyle.cursor = 'col-resize';

          if ((0, _dom.hasClass)(target, 'is-sortable')) {
            target.style.cursor = 'col-resize';
          }

          this.draggingColumn = column;
        } else if (!this.dragging) {
          bodyStyle.cursor = '';

          if ((0, _dom.hasClass)(target, 'is-sortable')) {
            target.style.cursor = 'pointer';
          }

          this.draggingColumn = null;
        }
      }
    },
    handleMouseOut: function handleMouseOut() {
      if (this.$isServer) return;
      document.body.style.cursor = '';
    },
    handleCellMouseEnter: function handleCellMouseEnter(event, column) {
      var cell = (0, _util.getCell)(event);
      var cellChild = event.target.querySelector('.cell'); // if (!hasClass(cellChild, 'el-tooltip')) {
      //   return;
      // }

      var referenceElm = event.target.querySelector('.referenceElm');
      var range = document.createRange();
      range.setStart(cellChild, 0);
      range.setEnd(cellChild, cellChild.childNodes.length);
      var rangeWidth = range.getBoundingClientRect().width;
      var padding = (parseInt((0, _dom.getStyle)(cellChild, 'paddingLeft'), 10) || 0) + (parseInt((0, _dom.getStyle)(cellChild, 'paddingRight'), 10) || 0);

      if ((rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
        var tooltip = this.$refs.tooltip;
        this.tooltipContent = cell.textContent || cell.innerText;
        var popperContainer = tooltip.$refs.popper.childNodes[0];
        var tipContent = this.tooltipContent.outerHTML || this.tooltipContent;

        if (tipContent === '' || tipContent === undefined || tipContent === null) {
          return;
        }

        popperContainer.textContent = tipContent;
        popperContainer.innerText = tipContent;
        tooltip.referenceElm = referenceElm || cell;
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
        tooltip.doDestroy();
        tooltip.setExpectedState(true);
        this.activateTooltip(tooltip);
      }
    },
    handleCellMouseLeave: function handleCellMouseLeave(event) {
      var tooltip = this.$refs.tooltip;

      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }
    },
    toggleOrder: function toggleOrder(_ref) {
      var order = _ref.order,
          sortOrders = _ref.sortOrders;
      if (order === '') return sortOrders[0];
      var index = sortOrders.indexOf(order || null);
      return sortOrders[index > sortOrders.length - 2 ? 0 : index + 1];
    },
    handleSortClick: function handleSortClick(event, column, givenOrder) {
      event.stopPropagation();
      var order = givenOrder || this.toggleOrder(column);
      var target = event.target;

      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (target && target.tagName === 'TH') {
        if ((0, _dom.hasClass)(target, 'noclick')) {
          (0, _dom.removeClass)(target, 'noclick');
          return;
        }
      }

      if (!column.sortable) return;
      var states = this.store.states;
      var sortProp = states.sortProp;
      var sortOrder;
      var sortingColumn = states.sortingColumn;

      if (sortingColumn !== column || sortingColumn === column && sortingColumn.order === null) {
        if (sortingColumn) {
          sortingColumn.order = null;
        }

        states.sortingColumn = column;
        sortProp = column.property;
      }

      if (!order) {
        sortOrder = column.order = null;
        states.sortingColumn = null;
        sortProp = null;
      } else {
        sortOrder = column.order = order;
      }

      states.sortProp = sortProp;
      states.sortOrder = sortOrder;
      this.store.commit('changeSortCondition');
    }
  },
  data: function data() {
    return {
      draggingColumn: null,
      dragging: false,
      dragState: {},
      tooltipContent: ''
    };
  }
};
exports["default"] = _default2;